import React from 'react';

function UserProfile({ username, onLogout }) {
  return (
    <div className="px-4 py-3 border-t border-gray-300 dark:border-gray-700 bg-gray-300 dark:bg-gray-700 flex items-center justify-between">
      <div className="flex items-center">
        <span className="font-medium text-gray-800 dark:text-gray-200 mr-2 truncate">
          {username || 'Utilizator'}
        </span>
      </div>
      <button
        onClick={onLogout}
        className="p-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
        title="Deconectare"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M17 16a3 3 0 01-3 3H6a3 3 0 01-3-3V4a3 3 0 013-3h8a3 3 0 013 3v2h-2V4a1 1 0 00-1-1H6a1 1 0 00-1 1v12a1 1 0 001 1h8a1 1 0 001-1v-2h2v2z" clipRule="evenodd" />
          <path d="M14 7h-3V5h3v2zm5 1.5l-4.5 4.5V11h-6v-2h6V7.5l4.5 4.5z" />
        </svg>
      </button>
    </div>
  );
}

export default UserProfile; 